import { UxNotificationSeverityEnum } from "../interface";
import { NOTIFICATION_API_BASEURLS, NOTIFICATION_API_VERSION } from "./constants";
export const getApiBaseUrl = (stage) => {
    const baseUrl = NOTIFICATION_API_BASEURLS[stage] || NOTIFICATION_API_BASEURLS.prod;
    return `${baseUrl}/${NOTIFICATION_API_VERSION}`;
};
export const mapSeverity = (severity) => {
    return ({
        INFORMATION: UxNotificationSeverityEnum.Information,
        WARNING: UxNotificationSeverityEnum.Warning,
        ERROR: UxNotificationSeverityEnum.Error
    }[`${severity}`.toUpperCase()] || UxNotificationSeverityEnum.Information);
};
export const mapNotification = (notification, categories) => {
    const category = categories
        ? categories.find(({ name }) => name === notification.category)
        : null;
    const categoryTitle = (category === null || category === void 0 ? void 0 : category.title) || notification.category;
    return Object.assign(Object.assign({}, notification), { id: notification.id || `myt-${notification.timestamp}`, severity: mapSeverity(notification.severity), sourceName: notification.sourceName || categoryTitle });
};
const getRequestOptions = (token) => {
    return {
        headers: token
            ? {
                "X-JWT-Assertion": token
            }
            : {}
    };
};
export const fetchNotifications = async ({ stage, locale, token }) => {
    const url = `${getApiBaseUrl(stage)}/notifications?locale=${locale.slice(0, 2)}`;
    return await fetch(url, getRequestOptions(token));
};
export const fetchCategories = async ({ stage, locale, token }) => {
    const url = `${getApiBaseUrl(stage)}/categories?locale=${locale.slice(0, 2)}`;
    return await fetch(url, getRequestOptions(token));
};
//# sourceMappingURL=api.js.map
